import {
  Breadcrumbs as MuiBreadcrumbs,
  makeStyles,
  Link,
  Typography,
} from '@material-ui/core';
import { camelToTitleCase } from '../../lib/formatters';
import { Link as RouterLink, useLocation } from 'react-router-dom';

export const Breadcrumbs = () => {
  const classes = useStyles();
  const location = useLocation();
  const links =
    location.pathname !== '/'
      ? location.pathname.split('/').slice(1)
      : ['Dashboard'];

  return (
    <div className={classes.breadcrumb}>
      <MuiBreadcrumbs>
        {links.map((link: string, index: number) => {
          const last = index === links.length - 1;
          const to = `${links.slice(0, index + 1).join('/')}`;

          return last ? (
            <Typography
              className={classes.link}
              key={`breadcrumb-${index}`}
              variant="caption"
            >
              {camelToTitleCase(link === '' ? 'Dashboard' : link)}
            </Typography>
          ) : (
            <Link
              className={classes.link}
              key={`breadcrumb-${index}`}
              component={RouterLink as any}
              to={to}
              underline="hover"
              variant="caption"
            >
              {camelToTitleCase(link)}
            </Link>
          );
        })}
      </MuiBreadcrumbs>
    </div>
  );
};

const useStyles = makeStyles((theme: any) => ({
  breadcrumb: {
    position: 'fixed',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    height: 30,
    minWidth: 160,
    fontWeight: 300,
    borderRadius: '0px 0px 100px 0px',
    padding: '0px 35px 0px 15px',
    backgroundColor: theme.palette.primary.main,
    zIndex: 900,
  },
  breadcrumbText: {
    color: 'white !important',
    fontSize: 12,
    fontWeight: 300,
  },
  link: {
    color: 'white',
    '&:hover, &:active, &:focus': {
      color: 'white',
    },
  },
}));
